module.exports = __webpack_public_path__ + "static/support-6dd230886c641812fdb01d0ed1072207.png";